import { axiosInstance } from '../axios';
import { AuthorizeRequest, AuthorizeResponse } from '../models/Authorize';
import { ApiResponse } from '../models/ApiResponse';
import { authLoginURL } from '../../constants/urls';

export const Authorize = async (authData: AuthorizeRequest) => {
  const params = new URLSearchParams({ ...authData });

  const result = await axiosInstance.post<AuthorizeResponse>('token', params, {
    baseURL: authLoginURL,
  });

  return result.data;
};

export const revokeToken = async () => {
  const result = await axiosInstance.post<ApiResponse<boolean>>(`${authLoginURL}token/revoke`);
  return result.data;
};
